export class Vendor {
  public id: string

  constructor(public name: string) {}
}
